import reviewWidget from "./components/reviewWidget.vue";

export function createApp() {
    Vue.component( "review-widget", reviewWidget );
}
